import styled from "styled-components";

export const Card = styled.div`
  display: flex;
  padding: 20px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid var(--line-secondary-n-300, #e0e0e8);
  background: #fff;
`;

export const TopSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const IconContainer = styled.div`
  position: relative;
  flex-shrink: 0;
`;

export const StatusIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 51px;
  height: 51px;
  background: var(--Background-Secondary, #f8f7fc);
  border-radius: 10px;
  position: relative;
  padding: 5px;
`;

export const StatusText = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 22px;
`;

export const Separator = styled.div`
  width: 100%;
  height: 1px;
  stroke-width: 1px;
  stroke: var(--line-secondary-n-300, #e0e0e8);
  border-top: 1px dashed var(--line-secondary-n-300, #e0e0e8);
`;

export const DeliverySection = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
`;

export const DeliveryIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const DeliveryLabel = styled.div`
  color: var(--text-secondary-n-400, #5b5675);
  font-family: "Euclid Circular B";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;

export const DeliveryDateTime = styled.div`
  color: var(--text-primary-n-600, #040222);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
  letter-spacing: -0.1px;
`;

export const DeliveryDetailsLink = styled.div`
  color: var(--button-hyperlink-b-300, #1b73e8);
  font-family: "Euclid Circular B";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 20px;
`;
